module.exports = __webpack_public_path__ + "img/strategy.1c3eb346.svg";